import React from 'react';
import { tabChange } from '../../helpers/uiFunctions/uiActions';

class ToolTabs extends React.Component {
    render() {

        return(
            <div className="tabs-wrapper">
                <div id="crmtest-tabs" className="tabs">
                    <div id="tab-1" className="tab crmtest-1 active" onClick={() => tabChange("crmtest", "1")}>Email Template Test</div>
                    <div id="tab-2" className="tab crmtest-2" onClick={() => tabChange("crmtest", "2")}>Send Newsletter</div>
                    <div id="tab-3" className="tab crmtest-3" onClick={() => tabChange("crmtest", "3")}>Scheduled Newsletters</div>
                    <div id="tab-4" className="tab crmtest-4" onClick={() => tabChange("crmtest", "4")}>Email Template Delivery Report</div>
                </div>
            </div>
        )
    }
}
export default ToolTabs;


// WEBPACK FOOTER //
// ./src/component_crmTest/components/ToolTabs.js